// extracted by mini-css-extract-plugin
export default {"addedCriteria":"EligibilityCriteria_addedCriteria__XMcmp"};